<template>
  <BContainer
    class="p-0"
    fluid
  >
    <ValidationObserver
      ref="user"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="First Name"
              label-for="fFirstName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fFirstName"
                v-model="user.first_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Last Name"
              label-for="fLastName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fLastName"
                v-model="user.last_name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol cols="12" />

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Mobile Number"
              label-for="fMobileNumber"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fMobileNumber"
                v-model="user.mobile_number"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Email"
              label-for="fEmail"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fEmail"
                v-model="user.email"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <ValidationProvider
              v-slot="{ errors }"
              name="username"
              vid="username"
              rules="required|max:50"
            >
              <BFormGroup
                label="Username"
                label-for="username"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="username"
                  v-model="user.username"
                  disabled
                />
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Notification Email"
              label-for="fNotificationEmail"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fNotificationEmail"
                v-model="user.notification_email"
                disabled
              />
            </BFormGroup>
          </BCol>

        </BRow>
      </form>
    </ValidationObserver>
  </BContainer>
</template>
<script>
import MISC from '@/mixins/misc'

export default {
  name: 'VAgentInformations',

  emits: ['updated'],

  mixins: [
    MISC
  ],

  props: {
    user: {
      type: Object,
      default: () => ({
        id: '',
        username: '',
        name: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        email: '',
        notification_email: '',
        role: '',
        role_name: '',
        cluster: '',
        provinces: [],
        photo_url: ''
      })
    }
  }
}
</script>
